import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "./SimilarPostsPage.module.css";
import { useTranslation } from "@i18n";
import { useParams } from "react-router-dom";
import Loader from "@componentsShared/Loader/Loader";
import { api__getSimilarPosts } from "@/apis/posts/similar";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import useApi from "@hooks/useApi";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var SimilarPostsPage = function SimilarPostsPage() {
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useParams = useParams(),
    postId = _useParams.postId; // Extract postId from URL params
  var _useApi = useApi([postId], function () {
      return api__getSimilarPosts(+postId);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    similar = _useApi2[2];
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    mainClass: "SimilarPostsPage",
    linksForSearch: true,
    authenticationMsg: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    loading: true,
    headHideLinks: true,
    mobileHasTitle: t("سيارات مشابهة", {
      ns: "web_post_view"
    }),
    mobileNoLogo: true
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("span", {
    className: ["m-show ", stl.mobileBack].join(" "),
    onClick: function onClick() {
      history.back();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(CDN_LINK, "/assets/images/mobileBackBlueArr.svg"),
    alt: "back"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "m-hide"
  }, t("سيارات مشابهة", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-[repeat(auto-fill,minmax(273px,1fr))] gap-5 lg:max-w-[1158px] lg:mx-auto"
  }, similar.length > 0 && (similar === null || similar === void 0 ? void 0 : similar.map(function (post, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      rank: i + 1,
      sectionType: "similar items",
      key: post.id
    }));
  }))), /*#__PURE__*/React.createElement("a", {
    className: ["redBtn", stl.moreSimilar, '!mt-10'].join(" "),
    href: createUrl("/autos")
  }, " ", t("تصفح جميع السيارات ", {
    ns: "web_post_view"
  }))));
};
export default SimilarPostsPage;